import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import LinkIcon from "@mui/icons-material/Link";
import LinkOffIcon from "@mui/icons-material/LinkOff";
import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash';
import RestoreIcon from '@mui/icons-material/Restore';
import { IconButton, Stack, FormControl, InputLabel, Select, MenuItem, CircularProgress, Checkbox, FormControlLabel, TextField } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import { DataGrid } from '@mui/x-data-grid';
import { default as React, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "../../config/authaxios";
import Dropdown from "../../css/dropdown.module.scss";
import LinkCategory from "../coupon/category/LinkCategory";
import UnLinkCategory from "./category/UnLinkCategory";


import { useDispatch } from "react-redux";

import { getQwikVoucehersAction } from "../../redux/quick-silver/getQuickSilverCoupons";
import { useStyles } from '../../theme/theme';

// global veriables
let propsData = {};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const publisherLinkModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 420,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "12px",
};

function Qacoupon() {
  // state---->
  const [linkCategory, setLinkCategory] = useState(false);
  const [unlinkCategory, setUnLinkCategory] = useState(false);
  const [openPublisherLink, setOpenPublisherLink] = useState(false);
  const [selectedProductSku, setSelectedProductSku] = useState("");
  const [publishers, setPublishers] = useState([]);
  const [selectedPublisher, setSelectedPublisher] = useState("");
  const [publisherCategories, setPublisherCategories] = useState([]);
  const [selectedPublisherCategory, setSelectedPublisherCategory] = useState("");
  const [loadingPublishers, setLoadingPublishers] = useState(false);
  const [loadingPublisherCategories, setLoadingPublisherCategories] = useState(false);
  const [linkingPublisherCategory, setLinkingPublisherCategory] = useState(false);
  const [isPopularCategory, setIsPopularCategory] = useState(false);
  const [popularPosition, setPopularPosition] = useState("");

  const navigate = useNavigate();

  let saveLimit=sessionStorage.getItem('limit') || 10
  let saveSelect=sessionStorage.getItem('select') || 1

  const [coupons, setCoupons] = useState([]);
  const [isdeleteId, setIsDeleteId] = useState();

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(saveLimit);
  const [isUsed, setIsUsed] = useState(false);
  const [isDeleted, setIsDeleted] = useState(false);
  const [select,setSelect]=useState(saveSelect)   //1- qwicksilver 4- upi 5- hubble

  const [isMore, setIsMore] = useState(false);
  const [load, setLoad] = useState(false);
  const [nodata, setNodata] = useState(false);

  const linkCategorySelector = useSelector((state) => state.linkCategory);
  const { status: statusLink } = linkCategorySelector;

  const unLinkCategorySelector = useSelector((state) => state.unlinkCategory);
  const { status: statusUnLink } = unLinkCategorySelector;
  const dispatchRTK = useDispatch()
  const getQwikVoucehersSelector = useSelector(state => state.getQwikVoucehers);
  const { data: couponData = [], loading } = getQwikVoucehersSelector;


  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [pageSize, setPageSize] = useState(25);
  const classes = useStyles();

  // const qSColomns = [
  //   {
  //     field: 's_no',
  //     headerName: 'S. No.',
  //     headerClassName: 'super-app-theme--header',
  //     flex: 1,
  //     filterable: false,
  //     renderCell: (index) => index.api?.getRowIndexRelativeToVisibleRows(index.row._id) + 1,
  //   },
  //   {
  //     field: '_id',
  //     headerName: 'ID',
  //     headerClassName: 'super-app-theme--header',
  //     flex: 1,
  //     minWidth: 200,
  //   },
  //   {
  //     field: 'name',
  //     headerName: 'Name',
  //     headerClassName: 'super-app-theme--header',
  //     flex: 1,
  //     minWidth: 200,
  //   },
  //   {
  //     field: 'image',
  //     headerName: 'Image',
  //     headerClassName: 'super-app-theme--header',
  //     flex: 1,
  //     minWidth: 200,
  //     renderCell: (params) => {
  //       return (
  //         <>
  //           <img width={40} src={params?.row?.images?.mobile} />
  //         </>
  //       )
  //     },
  //   },
  //   {
  //     field: 'price',
  //     headerName: 'Price',
  //     headerClassName: 'super-app-theme--header',
  //     flex: 1,
  //     minWidth: 700,
  //     minHeight: 500,
  //     renderCell: (params) => {
  //       return (
  //         <>
  //           <Stack direction={"row"}>
  //             {params?.row?.price?.denominations?.map((price, idx) => {
  //               return <Typography key={idx}>{price + ","}</Typography>
  //             })}
  //           </Stack>
  //         </>
  //       )
  //     },
  //   },
  //   {
  //     field: 'profit', headerName: 'Add Profit',
  //     renderCell: (params) => {
  //       return (
  //         <IconButton
  //           onClick={() => navigate(`/detailCoupon?SKU=${params?.row?.sku}&prices=${params?.row?.price?.denominations}`)}><LinkIcon color='primary' />
  //         </IconButton>
  //       )
  //     },
  //     headerClassName: 'super-app-theme--header',
  //     flex: 1,
  //     minWidth: 150,
  //   },
  //   {
  //     field: 'wallet',
  //     headerName: 'Wallet',
  //     headerClassName: 'super-app-theme--header',
  //     flex: 1,
  //     minWidth: 200,
  //   },
  //   {
  //     field: 'category',
  //     headerName: 'Linked Category',
  //     headerClassName: 'super-app-theme--header',
  //     flex: 1,
  //     minWidth: 200,
  //     renderCell: (params) => <Typography>{params?.row?.category?.name}</Typography>
  //   },
  //   {
  //     field: 'link_category', headerName: 'Link Category',
  //     renderCell: (params) => {
  //       return (
  //         <IconButton
  //           onClick={() => {
  //             setLinkCategory(true);
  //             propsData = {
  //               sku: params?.row?.sku,
  //             };
  //           }}><LinkIcon color='primary' />
  //         </IconButton>
  //       )
  //     },
  //     headerClassName: 'super-app-theme--header',
  //     flex: 1,
  //     minWidth: 150,
  //   },
  //   {
  //     field: 'unlink_category', headerName: 'Un-Link Category',
  //     renderCell: (params) => {
  //       return (
  //         <IconButton
  //           onClick={() => {
  //             setUnLinkCategory(true);
  //             propsData = {
  //               catId: params?.row?.category?.category_id,
  //               sku: params?.row?.sku,
  //               is_deleted: true,
  //             };
  //           }}><LinkOffIcon color='primary' />
  //         </IconButton>
  //       )
  //     },
  //     headerClassName: 'super-app-theme--header',
  //     flex: 1,
  //     minWidth: 150,
  //   },
  //   {
  //     field: 'edit', headerName: 'Edit Category',
  //     renderCell: (params) => {
  //       return (
  //         <IconButton
  //           onClick={() => {
  //             navigate(`/editqslist?couponId=${params?.row._id}`);
  //           }}><EditIcon color='primary' />
  //         </IconButton>
  //       )
  //     },
  //     headerClassName: 'super-app-theme--header',
  //     flex: 1,
  //     minWidth: 150,
  //   },
  //   {
  //     field: 'delete',
  //     headerName: 'Delete Category',
  //     renderCell: (params) => {
  //       return (
  //         <IconButton
  //           onClick={() => {
  //             handleOpen();
  //             setIsDeleteId(params?.row._id);
  //           }}><DeleteIcon color='error' />
  //         </IconButton>
  //       )
  //     },
  //     headerClassName: 'super-app-theme--header',
  //     flex: 1,
  //     minWidth: 150,
  //     hide: true,
  //   },
  //   {
  //     field: 'revert',
  //     headerName: 'Revert Category',
  //     renderCell: (params) => {
  //       return (
  //         <IconButton
  //           onClick={() => {
  //             setIsDeleteId(params?.row._id);
  //             restoreHandler();
  //           }}
  //         ><RestoreIcon color='success' />
  //         </IconButton>
  //       )
  //     },
  //     headerClassName: 'super-app-theme--header',
  //     flex: 1,
  //     hide: true,
  //   },
  //   {
  //     field: 'expiry',
  //     headerName: 'Expiry',
  //     headerClassName: 'super-app-theme--header',
  //     flex: 1,
  //     minWidth: 200,
  //   },
  //   {
  //     field: 'created_at',
  //     headerName: 'Created At',
  //     headerClassName: 'super-app-theme--header',
  //     flex: 1,
  //     minWidth: 200,
  //   },
  //   {
  //     field: 'updated_at',
  //     headerName: 'Updated At',
  //     headerClassName: 'super-app-theme--header',
  //     flex: 1,
  //     minWidth: 200,
  //   },
  // ]



  const deleteHandler = async () => {
    const res = await axios.delete("/admin/qwik-voucehrs", {
      data: { voucherId: isdeleteId, is_deleted: true },
    });
    const data = await res.data;
    if (data) {
      alert(res.data.message);
      handleClose();
      setCoupons([]);
      dispatchRTK(getQwikVoucehersAction({ page: page, limit: limit, isDeleted: isDeleted }))
    }
  };

  const restoreHandler = async () => {
    const res = await axios.delete("/admin/qwik-voucehrs", {
      data: { voucherId: isdeleteId, is_deleted: false },
    });
    const data = await res.data;
    if (data) {
      alert(res.data.message);
      handleClose();
      setCoupons([]);
      dispatchRTK(getQwikVoucehersAction({ page: page, limit: limit, isDeleted: isDeleted }))
    }
  };

  const fetchPublishers = () => {
    setLoadingPublishers(true);
    axios
      .get(`/admin/publishers/name-id`)
      .then((res) => {
        if (res.data.status_code == 401) {
          localStorage.clear();
        }
        if (res.data.status) {
          setPublishers(res.data.response || res.data.data || []);
        } else {
          setPublishers([]);
        }
      })
      .catch((err) => {
        console.error("Error fetching publishers:", err);
        setPublishers([]);
      })
      .finally(() => {
        setLoadingPublishers(false);
      });
  };

  const fetchPublisherCategories = (publisherId) => {
    setLoadingPublisherCategories(true);
    axios
      .get(`/admin/publisher/categories/${publisherId}/false`)
      .then((res) => {
        if (res.data.status_code == 401) {
          localStorage.clear();
        }
        if (res.data.status) {
          setPublisherCategories(res.data.response || res.data.data || []);
        } else {
          setPublisherCategories([]);
        }
      })
      .catch((err) => {
        console.error("Error fetching publisher categories:", err);
        setPublisherCategories([]);
      })
      .finally(() => {
        setLoadingPublisherCategories(false);
      });
  };

  const handleOpenPublisherLink = (sku) => {
    setSelectedProductSku(sku);
    setSelectedPublisher("");
    setSelectedPublisherCategory("");
    setPublisherCategories([]);
    setIsPopularCategory(false);
    setPopularPosition("");
    setOpenPublisherLink(true);
    fetchPublishers();
  };

  const handlePublisherChange = (publisherId) => {
    setSelectedPublisher(publisherId);
    setSelectedPublisherCategory("");
    setPublisherCategories([]);
    setIsPopularCategory(false);
    setPopularPosition("");
    if (publisherId) {
      fetchPublisherCategories(publisherId);
    }
  };

  const handleLinkPublisherCategory = () => {
    if (!selectedPublisher || !selectedPublisherCategory || !selectedProductSku) {
      alert("Please select publisher and category");
      return;
    }

    if (isPopularCategory && !popularPosition) {
      alert("Please enter a position");
      return;
    }

    setLinkingPublisherCategory(true);
    axios
      .post(`/admin/publisher/category/voucher`, {
        publisher_id: selectedPublisher,
        category_id: selectedPublisherCategory,
        product_sku: selectedProductSku,
        is_popular_category: isPopularCategory,
        ...(isPopularCategory ? { position: Number(popularPosition) } : {}),
      })
      .then((res) => {
        if (res.data.status_code == 401) {
          localStorage.clear();
        }
        alert(res?.data?.message || "Category linked with voucher successfully");
        if (res.data.status) {
          setOpenPublisherLink(false);
          setSelectedPublisher("");
          setSelectedPublisherCategory("");
          setPublisherCategories([]);
          setIsPopularCategory(false);
          setPopularPosition("");
        }
      })
      .catch((err) => {
        alert(
          err?.response?.data?.message ||
            "Failed to link publisher category with voucher."
        );
      })
      .finally(() => {
        setLinkingPublisherCategory(false);
      });
  };

  useEffect(() => {
    dispatchRTK(getQwikVoucehersAction({ page: page, limit: limit, isDeleted: isDeleted,select:select }))

  }, [isDeleted, limit, statusLink, statusUnLink,select]);

  const Showmore = () => {
    setNodata(true);
    setIsMore(false);
    setLoad(true)
    axios
      .get(`/admin/qwik-voucehrs/${page}/${limit}/${isDeleted}/${select}`)
      .then((res) => {
        let data = Array.isArray(res.data.response) ? res.data.response : [];
        if (data.length === 0) {
          setNodata(false);
          setIsMore(true);
        }
        let temp = [...coupons, ...data];

        if (data.length < limit) {
          setIsMore(true);
        }

        setLoad(true)
        setCoupons(temp);
        setNodata(false);
        setPage(page + 1);
        // //console.log(res.data);
      });
  };

  return (
    <>
      <section>
        <section>
          <Stack direction='row' spacing={2}>
            <div className={Dropdown.dropdown}>
              {coupons.length > 0 && !isMore && (
                <Button variant="contained" color='info' onClick={Showmore}>
                  More
                </Button>
              )}
            </div>

            <div className={Dropdown.dropdown}>
              <Button variant="contained" color='info' >limit:{limit}</Button>
              <div className={Dropdown.dropdown_content}>
                <a
                  className={limit === 25 ? "disabled" : "notDisabled"}
                  onClick={() => {
                    setLimit(25);
                    setPage(0);
                    sessionStorage.setItem("limit",25)
                  }}
                >
                  25
                </a>

                <a
                  disabled={limit === 50 ? true : false}
                  onClick={() => {
                    setLimit(50);
                    setPage(0);
                    sessionStorage.setItem("limit",50)

                  }}
                >
                  50
                </a>
                <a
                  disabled={limit === 100 ? true : false}
                  onClick={() => {
                    setLimit(100);
                    setPage(0);
                    sessionStorage.setItem("limit",100)

                  }}
                >
                  100
                </a>
                <a
                  disabled={limit === 500 ? true : false}
                  onClick={() => {
                    setLimit(500);
                    setPage(0);
                    sessionStorage.setItem("limit",500)

                  }}
                >
                  500
                </a>
                <a
                  disabled={limit === 1000 ? true : false}
                  onClick={() => {
                    setLimit(1000);
                    setPage(0);
                    sessionStorage.setItem("limit",1000)

                  }}
                >
                  1000
                </a>
              </div>
            </div>

            <div className={Dropdown.dropdown}>
              <Button variant="contained" color='info'  >Is Deleted</Button>
              <div
                className={Dropdown.dropdown_content}
                style={{ zIndex: "10" }}
              >
                <a
                  onClick={() => {
                    setIsDeleted(false);
                  }}
                >
                  false
                </a>
                <a
                  onClick={() => {
                    setIsDeleted(true);
                  }}
                >
                  true
                </a>
              </div>
            </div>

            <div className={Dropdown.dropdown}>
              <Button variant="contained" color='info'  >{select==1?'qwicksilver':select==4?'upi':'hubble'}</Button>
              <div
                className={Dropdown.dropdown_content}
                style={{ zIndex: "10" }}
              >
                <a
                  onClick={() => {
                    setSelect(1);
                    setPage(0);
                    sessionStorage.setItem('select',1)
                  }}
                >
                  qwicksilver
                </a>
                <a
                  onClick={() => {
                    setSelect(4);
                    setPage(0);
                    sessionStorage.setItem('select',4)

                  }}
                >
                  upi
                </a>
                <a
                  onClick={() => {
                    setSelect(5);
                    setPage(0);
                    sessionStorage.setItem('select',5)
                  }}
                >
                  hubble
                </a>
              </div>
            </div>
           
            {loading && <Box sx={{ display: 'flex' }}>
              <CircularProgress />
            </Box>}
          </Stack>
        </section>

        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Are you Sure you want to Delete?
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              <Button
                onClick={() => {
                  deleteHandler();
                }}
              >
                Yes
              </Button>
              <Button onClick={handleClose}>No</Button>
            </Typography>
          </Box>
        </Modal>
      </section >
      <div
        className={Dropdown.dropdown}
        style={{ margin: "10px", display: "flex", justifyContent: "flex-end" }}
      >
        {coupons.length > 0 && !isMore && (
          <Button
            variant="contained" color='info'
            onClick={Showmore}
          >
            More
          </Button>
        )}
      </div>

      {/* <Paper sx={{
        bgcolor: '#fff',
        '& .super-app-theme--header': {
          bgcolor: '#DC8449',
          color: '#fff',
        },
      }} elevation={0}>


        <DataGrid
          className={classes.root}
          sx={{
            border: 0,
            overflowY: "scroll",

          }}
          hideFooterPagination
          // getRowHeight={() => 'auto'}
          autoHeight
          rows={data}
          columns={qSColomns}
          getRowId={(row) => row._id}
          disableSelectionOnClick
          disableRowSelectionOnClick
          experimentalFeatures={{ newEditingApi: true }}
          // pagination
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          rowsPerPageOptions={[25, 50, 100]}
          disableColumnSelector
          columnVisibilityModel={{
            delete: !isDeleted,
            revert: isDeleted
          }}
        />
      </Paper> */}

      <div style={{ width: "75vw", height: "35vw", overflow: "auto" }}>
        <table style={{ borderCollapse: "collapse" }}>
          <thead style={{ background: "#DC8449", color: "#fff", position: "sticky", top: "0px" }}>
            <tr>
              <th>S. No.</th>
              <th>Id</th>
              <th>Name</th>
              <th>Sku</th>
              <th>Image</th>
              <th>Delivery Type</th>
              <th>Country/Currency</th>
              <th>Price</th>
              <th>Min</th>
              <th>Max</th>
              <th>Add Profit</th>
              <th>Wallet</th>
              <th>Linked Category</th>
              <th>Global Linked</th>
              <th>Publisher Link</th>
              <th>Edit</th>
              <th>Delete</th>
              <th>Revert</th>
              <th>Expiry</th>
              <th>Created at</th>
              <th>Updated at</th>

            </tr>
          </thead>
          <tbody>
            {couponData.length > 0 ? couponData.map((item, index) => {
              return (

                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item?._id}</td>
                  <td>{item?.name}</td>
                  <td>{item?.sku}</td>
                  <td><img src={item?.images?.mobile} width="50px" /></td>
                  <td>{item?.delivery_type}</td>
                  <td>
                    {item?.country?.length > 0 ? item?.country[0]?.name : "—"} / {item?.currency || "—"}
                  </td>

                  <td>{item?.price?.denominations?.map((price, idx) => {
                    return <h6 key={idx}>{price + ","}</h6>
                  })}</td>
                  <td>{item?.price?.min}</td>

                  <td>{item?.price?.max}</td>

                  <td><IconButton
                    onClick={() => navigate(`/detailCoupon?SKU=${item?.sku}&prices=${item?.price?.denominations}`)}><LinkIcon color='primary' />
                  </IconButton></td>
                  <td>{item?.wallet}</td>
                  <td>
                    {item?.category?.name
                      ? `${item?.category?.name} (Position: ${item?.category?.c_position ?? "—"})`
                      : "---"}
                  </td>
                  <td>
                    <Stack direction="row" spacing={0.5} alignItems="center">
                      <IconButton
                        onClick={() => {
                          setLinkCategory(true);
                          propsData = {
                            sku: item?.sku,
                          };
                        }}
                      >
                        <LinkIcon color="primary" />
                      </IconButton>
                      <IconButton
                        onClick={() => {
                          setUnLinkCategory(true);
                          propsData = {
                            catId: item?.category?.category_id,
                            sku: item?.sku,
                            is_deleted: true,
                          };
                        }}
                      >
                        <LinkOffIcon color="primary" />
                      </IconButton>
                    </Stack>
                  </td>
                  <td>
                    <Stack direction="row" spacing={0.5} alignItems="center">
                      <Button
                        variant="contained"
                        size="small"
                        onClick={() => handleOpenPublisherLink(item?.sku)}
                      >
                        Publisher Linked
                      </Button>
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() =>
                          navigate(
                            `/qscoupon-publisher-links?sku=${encodeURIComponent(
                              item?.sku || ""
                            )}&name=${encodeURIComponent(item?.name || "")}`
                          )
                        }
                      >
                        Details
                      </Button>
                    </Stack>
                  </td>
                  <td>
                    <IconButton
                      onClick={() => {
                        navigate(`/editqslist?couponId=${item._id}`);
                      }}><EditIcon color='primary' />
                    </IconButton>
                  </td>
                  <td>
                    {(item?.is_deleted || isDeleted) ? (
                      <IconButton
                        onClick={() => {
                          axios
                            .delete("/admin/qwik-voucehrs", {
                              data: { voucherId: item._id, is_deleted: false },
                            })
                            .then((res) => {
                              if (res.data) {
                                alert(res.data.message);
                                setCoupons([]);
                                dispatchRTK(
                                  getQwikVoucehersAction({
                                    page: page,
                                    limit: limit,
                                    isDeleted: isDeleted,
                                    select: select,
                                  })
                                );
                              }
                            });
                        }}
                      >
                        <RestoreFromTrashIcon color="success" />
                      </IconButton>
                    ) : (
                      <IconButton
                        onClick={() => {
                          handleOpen();
                          setIsDeleteId(item?._id);
                        }}
                      >
                        <DeleteIcon color="error" />
                      </IconButton>
                    )}
                  </td>
                  <td>
                    <IconButton
                      onClick={() => {
                        setIsDeleteId(item._id);
                        restoreHandler();
                      }}
                    ><RestoreIcon color='success' />
                    </IconButton>
                  </td>
                  <td>
                    {item?.expiry}
                  </td>
                  <td>
                    {item?.created_at}
                  </td>
                  <td>
                    {item?.updated_at}
                  </td>





                </tr>
              );
            }) : <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>No Data Available</div>}
          </tbody>
        </table>
      </div>

      {/* modal */}
      {
        linkCategory && (
          <LinkCategory
            linkCategory={linkCategory}
            setLinkCategory={setLinkCategory}
            propsData={propsData}
          />
        )
      }
      {
        unlinkCategory && (
          <UnLinkCategory
            unlinkCategory={unlinkCategory}
            setUnLinkCategory={setUnLinkCategory}
            propsData={propsData}
          />
        )
      }

      <Modal
        open={openPublisherLink}
        onClose={() => setOpenPublisherLink(false)}
        aria-labelledby="publisher-link-modal-title"
        aria-describedby="publisher-link-modal-description"
      >
        <Box sx={publisherLinkModalStyle}>
          <Typography id="publisher-link-modal-title" variant="h6" component="h2">
            Publisher Linked
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            SKU: {selectedProductSku}
          </Typography>

          <FormControl fullWidth sx={{ mt: 2 }}>
            <InputLabel id="publisher-select-label">Publisher</InputLabel>
            <Select
              labelId="publisher-select-label"
              label="Publisher"
              value={selectedPublisher}
              onChange={(e) => handlePublisherChange(e.target.value)}
              disabled={loadingPublishers}
            >
              {publishers.map((publisher) => (
                <MenuItem key={publisher._id} value={publisher._id}>
                  {publisher.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {loadingPublishers && (
            <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
              <CircularProgress size={24} />
            </Box>
          )}

          <FormControlLabel
            sx={{ mt: 1 }}
            control={
              <Checkbox
                checked={isPopularCategory}
                onChange={(e) => {
                  setIsPopularCategory(e.target.checked);
                  setSelectedPublisherCategory("");
                  setPopularPosition("");
                }}
              />
            }
            label="Is Popular"
          />

          {isPopularCategory && (
            <TextField
              fullWidth
              type="number"
              label="Position"
              sx={{ mt: 2 }}
              value={popularPosition}
              onChange={(e) => setPopularPosition(e.target.value)}
            />
          )}

          <FormControl fullWidth sx={{ mt: 2 }}>
            <InputLabel id="publisher-category-select-label">Category</InputLabel>
            <Select
              labelId="publisher-category-select-label"
              label="Category"
              value={selectedPublisherCategory}
              onChange={(e) => setSelectedPublisherCategory(e.target.value)}
              disabled={!selectedPublisher || loadingPublisherCategories}
            >
              {publisherCategories
                .filter((category) => !!category.is_popular_category === isPopularCategory)
                .map((category) => (
                  <MenuItem key={category._id} value={category._id}>
                    {category.name} (Position: {category.position})
                  </MenuItem>
                ))}
            </Select>
          </FormControl>

          {loadingPublisherCategories && (
            <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
              <CircularProgress size={24} />
            </Box>
          )}

          <Box
            sx={{ display: "flex", justifyContent: "flex-end", mt: 3, gap: 2 }}
          >
            <Button
              onClick={() => {
                setOpenPublisherLink(false);
                setIsPopularCategory(false);
                setPopularPosition("");
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleLinkPublisherCategory}
              disabled={linkingPublisherCategory}
            >
              {linkingPublisherCategory ? "Creating..." : "Create"}
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default Qacoupon;